import React from 'react';
import DropdownList from 'react-widgets/lib/DropdownList';

const DropdownField = ({ input, meta: { touched, error }, ...rest }) => (
  <div>
    <DropdownList {...input} {...rest} />
    <div>{touched && (error && <span className="text-danger">{error}</span>)}</div>
  </div>
);
export default DropdownField;



// WEBPACK FOOTER //
// ./src/components/form/DropdownField.js